import { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { connect } from "src/store/connect";
import { BlockTypesLabels } from "src/config/constants";
import Options from "./GeneralForm/Options";
import { Button } from "@material-ui/core";
interface DeleteBlockConfirmationProps {
    onRemoveBlock: () => void;
    onCancel: () => void;
    targetBlock: Block;
};

const DeleteBlockConfirmation: FC<DeleteBlockConfirmationProps> = ({onRemoveBlock, onCancel, targetBlock}) => {
    const classes = useStyles();

    return (
      <div>
        <b className={classes.title}>Eliminar bloque {BlockTypesLabels[targetBlock.type]}</b>
        <hr className={classes.horizontalRule}/>
        <span>
          Eliminar un bloque también elimina <b>todos</b> los bloques siguientes a él
        </span>
        <div className={classes.blockContainer}>
          <span className={classes.optionsTitle}>Título del bloque</span>
          <b>{targetBlock.data.outgoingMessage}</b>
          {
            targetBlock.type === "multiple" &&
            <div className={classes.optionsContainer}>
              <span className={classes.optionsTitle}>Respuestas</span>
              <Options targetBlock={targetBlock} />
            </div>
          }
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            variant='contained'
            onClick={onCancel}
            disableElevation
            className={`${classes.button} ${classes.whiteButton}`}
          >
            Cancelar
          </Button>
          <Button
            variant='contained'
            onClick={onRemoveBlock}
            color='primary'
            className={classes.button}
          >
            Eliminar
          </Button>
        </div>
      </div>
    );
};

DeleteBlockConfirmation.defaultProps = { };

export default connect(DeleteBlockConfirmation);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: "#ffffff",
    width: "348px",
    height: "488px",
    padding: "27px 23px 34px 26px",
    borderRadius: "8px",
    boxShadow: "0 2px 24px 0 rgba(0, 0, 0, 0.08)",
    border: "solid 1px #eff2f8",
    overflow: "auto",
  },
  title: {
    fontSize: '1.125rem',
    color: '#141A2A' // TODO: Add proper 600 font
  },
  horizontalRule: {
    borderColor: '#EFF2F8DD',
    margin: '1rem 0',
    borderBottom: 0
  },
  blockContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    background: 'rgba(0, 0, 0, 0.02)',
    border: '1px solid #D4DAE3',
    borderRadius: '8px',
    margin: '1rem 0',
    padding: '1rem'
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    marginTop: '1.5rem'
  },
  optionsTitle: {
    marginBottom: '.75rem'
  },
  buttonsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    columnGap: '1.5rem'
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    padding: '.5rem 0',
    textTransform: 'none',
    fontWeight: 'bold',
  },
  whiteButton: {
    backgroundColor: 'whitesmoke'
  }
}));
